import { Cuboid } from '@App/app/entities/layer/cuboid.model';
import { RectTube } from '@App/app/entities/layer/rect-tube.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Shared footer for rectangular layer property panels (cuboid, rect-tube):
 * the copy button, position, geolocation and orientation rows. Restricted to
 * cuboid/rect-tube layers, which carry the azimuth and down-tilt orientation.
 */
@Component({
  selector: 'app-layer-details-rect-footer',
  templateUrl: './layer-details-rect-footer.component.html',
})
export class LayerDetailsRectFooterComponent {
  @Input() layer: Cuboid | RectTube;
  @Output() copyClicked = new EventEmitter<void>();
}
